import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ShieldCheck, LineChart, Network, Cpu, Cable, BellRing, FileCheck2 } from "lucide-react";

export default function Technology() {
  return (
    <div>
      <section className="bg-[#0B3D6E] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="font-label text-xs text-[#2E7BC7]">Technology</div>
          <h1 className="mt-3 font-display font-black text-4xl md:text-6xl max-w-3xl">A logistics platform that plugs into your stack.</h1>
          <p className="mt-5 text-slate-300 max-w-2xl">Portals, APIs, real-time tracking, and integrations built for teams that expect their 3PL to move as fast as their business does.</p>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            { icon: MapPin, t: "Real-time tracking", d: "GPS + geo-fenced milestones with configurable event alerts." },
            { icon: ShieldCheck, t: "Secure portals", d: "SOC 2-aligned customer and carrier portals with granular RBAC." },
            { icon: LineChart, t: "Analytics", d: "Lane performance, cost-per-mile, on-time-in-full — dashboards you can act on." },
            { icon: Network, t: "Open APIs", d: "REST endpoints and webhooks. TMS-ready for your stack." },
            { icon: Cpu, t: "TMS integration", d: "Connect Oracle OTM, MercuryGate, McLeod, or homegrown TMS solutions." },
            { icon: Cable, t: "QuickBooks & CRM", d: "Two-way sync for invoices, payments, and customer records." },
            { icon: BellRing, t: "Event automation", d: "Slack, email, and webhook triggers on pickup, arrival, POD, delays." },
            { icon: FileCheck2, t: "Digital documents", d: "BOL, POD, and invoicing captured, indexed, and searchable." },
          ].map(({ icon: I, t, d }, i) => (
            <div key={t} className="border border-gray-200 rounded-lg p-6" data-testid={`tech-feature-${i}`}>
              <I className="h-6 w-6 text-[#2E7BC7]" />
              <div className="mt-4 font-display font-bold text-lg text-[#0B3D6E]">{t}</div>
              <p className="mt-2 text-sm text-slate-600">{d}</p>
            </div>
          ))}
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-14 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/portal/customer" className="btn-primary-apex" data-testid="tech-customer-portal-btn">Explore Customer Portal</Link>
          <Link to="/portal/carrier" className="btn-secondary-apex" data-testid="tech-carrier-portal-btn">Explore Carrier Portal</Link>
        </div>
      </section>
    </div>
  );
}
